import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=3f2da1e2"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2da1e2')) {
      api.createRecord('3f2da1e2', component.options)
    } else {
      api.reload('3f2da1e2', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=3f2da1e2", function () {
      api.rerender('3f2da1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/views/SignUp.vue"
export default component.exports